// action/visitorType/visitorTypeSelector.js
export const selectVisitorArr = (state) => state.visitorType.visitorArr;

// Bypass video status
export const selectBypass = (state) => state.visitorType.bypass;
